import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.1975 5.09906L10.1503 4.51031L8.34376 0.84375C8.25792 0.696061 8.13481 0.573492 7.98674 0.488296C7.83867 0.4031 7.67084 0.358261 7.50001 0.358261C7.32919 0.358261 7.16135 0.4031 7.01329 0.488296C6.86522 0.573492 6.74211 0.696061 6.65626 0.84375L4.8497 4.51125L0.802513 5.09906C0.629202 5.12392 0.466316 5.19681 0.332302 5.30948C0.198289 5.42215 0.0985046 5.5701 0.0442519 5.73657C-0.0100009 5.90303 -0.016554 6.08136 0.0253348 6.25136C0.0672236 6.42136 0.15588 6.57623 0.281263 6.69844L3.20908 9.55312L2.51814 13.5844C2.4886 13.7568 2.50788 13.934 2.57381 14.096C2.63973 14.2581 2.74967 14.3984 2.8912 14.5012C3.03272 14.604 3.20018 14.6652 3.37465 14.6778C3.54911 14.6904 3.72362 14.6539 3.87845 14.5725L7.50001 12.6684L11.1197 14.5706C11.2745 14.652 11.449 14.6885 11.6235 14.6759C11.798 14.6633 11.9654 14.6021 12.107 14.4993C12.2485 14.3965 12.3584 14.2562 12.4243 14.0942C12.4903 13.9321 12.5096 13.7549 12.48 13.5825L11.7891 9.55125L14.7188 6.69844C14.8438 6.57632 14.9323 6.42167 14.9741 6.25194C15.0159 6.08222 15.0095 5.90418 14.9554 5.73794C14.9014 5.57169 14.802 5.42386 14.6684 5.31113C14.5348 5.19841 14.3724 5.12528 14.1994 5.1L14.1975 5.09906Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconStar;
